export default {
  zh: {
    pauseAction: '暂停',
    ownerFilterPh: '归属人', ownerFilterTip: '按账户归属人过滤其名下账户的广告', ownerSearchPh: '搜索归属人…', searchAccountPh: '搜索账户…',
    columns: '自定义列', resultsFb: '成效（FB）', totalConversions: '综合转化（访问）',
    costPerResult: '单次成效费用', combinedCpa: '综合 CPA', ctrLabel: 'CTR',
    snapshot: '快照 {time}', snapshotUnknown: '快照时间未知', stIdleTitle: '已开启但下面没有投放中的广告——不消耗，点开关可整体启停',
    snapMin: '快照 {n} 分钟前', snapHour: '快照 {n} 小时前',
    staleSnapshot: '过期快照（{n} 小时未更新）',
    metricsAt: '指标更新于 {time}', allCampaigns: '全部系列', searchContext: '搜索名称、ID、账户或所属系列/组',
    fbMissing: '当前日期范围尚无完整 FB 成效数据', operationResults: '批量操作结果',
    verified: '已核验', unverified: '待核验', failed: '失败', actions: '操作',
    budgetUnverified: '预算已提交但未核验生效——请稍后点击「实时核验」确认',
    fbNotCollected: '该日期范围早于成效数据收集起点（2026-09-08），无 FB 成效实测数据——请看「综合转化」列',
    convTip: '综合转化 = FB 回传成效 与 真人落地访问量 取大（爬虫/审核机器人不计入）',
    breakdown: '细分', breakdownTitle: '细分 · {name}', breakdownAge: '年龄',
    breakdownGender: '性别', breakdownPlacement: '版位', breakdownDim: '维度',
    breakdownConvLoc: '转化位置',
    breakdownConvNote: '转化位置只细分成效；消耗、展示等行级指标无法按此维度拆分（与 FB 一致）',
    breakdownResults: '成效', breakdownEmpty: '该维度暂无数据（日期范围内无投放或无消耗）',
    breakdownFail: '细分加载失败：{msg}',
    createAd: '创建',
    pickTplTitle: '选择投放模板', pickTplPh: '搜索模板名 / 归属人…', pickTplEmpty: '无匹配模板',
    pickTplNone: '还没有模板——去新建一个',
    tplAgoNow: '刚刚', tplAgoMin: '{n} 分钟前', tplAgoHour: '{n} 小时前', tplAgoDay: '{n} 天前', tplAgoWeek: '{n} 周前',
  },
  en: {
    pauseAction: 'Pause',
    ownerFilterPh: 'Owner', ownerFilterTip: 'Show ads under accounts owned by the selected member', ownerSearchPh: 'Search owner…', searchAccountPh: 'Search account…',
    columns: 'Customize columns', resultsFb: 'Results (FB)', totalConversions: 'Combined (visits)',
    costPerResult: 'Cost per result', combinedCpa: 'Combined CPA', ctrLabel: 'CTR',
    snapshot: 'Snapshot {time}', snapshotUnknown: 'Snapshot time unavailable', stIdleTitle: 'On but no ads under it are delivering — zero spend; toggle to start/stop all',
    snapMin: 'Snapshot {n} min ago', snapHour: 'Snapshot {n} h ago',
    staleSnapshot: 'Stale snapshot ({n} h old)',
    metricsAt: 'Metrics updated {time}', allCampaigns: 'All campaigns', searchContext: 'Search name, ID, account, campaign or ad set',
    fbMissing: 'Complete FB results are not available for this date range', operationResults: 'Batch operation results',
    verified: 'Verified', unverified: 'Unverified', failed: 'Failed', actions: 'Actions',
    budgetUnverified: 'Budget submitted but not verified — click Live Verify to confirm',
    fbNotCollected: 'This date range predates the start of FB results collection (2026-09-08) — see the Combined conversions column',
    convTip: 'Combined = max(FB-reported results, real landing visits). Crawlers / review bots excluded',
    breakdown: 'Breakdown', breakdownTitle: 'Breakdown · {name}', breakdownAge: 'Age',
    breakdownGender: 'Gender', breakdownPlacement: 'Placement', breakdownDim: 'Segment',
    breakdownConvLoc: 'Conversion location',
    breakdownConvNote: 'Conversion location splits results only; row-level metrics like spend cannot be split by this dimension (same as FB)',
    breakdownResults: 'Results', breakdownEmpty: 'No data for this breakdown (no delivery or spend in range)',
    breakdownFail: 'Breakdown failed: {msg}',
    createAd: 'Create',
    pickTplTitle: 'Pick a Launch Template', pickTplPh: 'Search name or owner…', pickTplEmpty: 'No matching templates',
    pickTplNone: 'No templates yet — create one',
    tplAgoNow: 'just now', tplAgoMin: '{n} min ago', tplAgoHour: '{n} h ago', tplAgoDay: '{n} d ago', tplAgoWeek: '{n} w ago',
  },
}
